// Packages
import {
  Box,
  IconButton,
  Divider,
  Tooltip,
} from "@mui/material";

// Icon
import { ReactComponent as EditIcon } from "assets/images/icons/btn_edit.svg";
import { ReactComponent as DeleteIcon } from "assets/images/icons/icn_table_cell_Bin.svg";


export const getMainTableColumns = ({
  auth,
  columnHelper,
  permissions,
  theme,
  mainTableCallbacks
}) => {

  const {
    onEdit,
    onRemove
  } = mainTableCallbacks;

  return [
    columnHelper.accessor(row => row.name ?? "-", {
      id: "name",
      header: "RADIUS Server Name",
      cell: info => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.primary?.authenticateServer ?? "-", {
      id: "authenticateServer",
      header: "Primary Authenticate Server",
      cell: info => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.primary?.accounting?.accountingServer ?? "-", {
      id: "accountingServer",
      header: "Accounting Server",
      cell: info => <>{info.getValue()}</>,
    }),
    columnHelper.accessor(row => row.referencedServices ?? "-", {
      id: "referencedServices",
      header: "Referenced Services",
      cell: info => {
        const referencedServices = info.getValue();
        const count = referencedServices?.length || 0;
        return (
          <>
            {
              count === 0 && <Box>-</Box>
            }
            {
              count > 0 &&
              <Tooltip
                placement="bottom-start"
                arrow
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [-11, 0],
                        },
                      },
                    ],
                  },
                  arrow: {
                    sx: {
                      left: '10px !important',
                      transform: 'none !important',
                      '&::before': {
                        left: '0 !important',
                        transform: 'translateX(0) rotate(45deg) !important',
                      },
                    },
                  },
                }}
                title={
                  <Box>
                    {
                      referencedServices.map((service, index) => (
                        <Box
                          key={`reference-servicer-${service}-${index}`}
                          sx={{
                            fontSize: theme.typography.customFontSize[1],
                            fontWeight: theme.typography.customFontWeight[1],
                            lineHeight: 1.54,
                            color: theme.palette.primary.white,
                            whiteSpace: "pre-line"
                          }}>
                          {service}
                        </Box>
                      ))
                    }
                  </Box>
                }
              >
                <Box
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: count === 0 ? "default" : "pointer",
                    textDecoration: count === 0 ? "default" : "underline",
                  }}
                >
                  {count}
                </Box>
              </Tooltip>
            }
          </>
        )
      },
    }),
    columnHelper.display({
      id: "action",
      header: "Action",
      cell: info => {
        const selectedTarget = info.row.original;

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>

            <Divider orientation="vertical" flexItem sx={{ height: "20px", alignSelf: "center", margin: "2px" }} />

            <IconButton onClick={() => onEdit(selectedTarget)}><EditIcon /></IconButton>

            <Divider orientation="vertical" flexItem sx={{ height: "20px", alignSelf: "center", margin: "2px" }} />

            <IconButton onClick={() => onRemove(selectedTarget)}><DeleteIcon /></IconButton>

          </Box>
        )
      },
    }),
  ].filter(Boolean);
}